export default {"src":"/_next/static/media/fsn.011f8700.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};